/**
 * Legacy fallback entry — the bundle this file produces is loaded via
 * `<script nomodule>` in {@link ../index.html}, so it only ever runs in
 * browsers that ignore `<script type="module">`. The modern shell bundle
 * built from {@link ./main.tsx} is therefore never fetched on those
 * browsers.
 *
 * Imports are deliberately written against the real packages (not via
 * `@bestowinc/tinkertoy-shell-deps/*`) because this bundle has to be
 * fully self-contained: the import map that resolves shared deps in the
 * modern build is itself unsupported on browsers we're catching here.
 *
 * See {@link ../vite.fallback.config.ts} for the IIFE / no-externals
 * build configuration.
 */
import { PURPLE_THEME } from "@bestowinc/kindred-ds";
import { BrowserNotSupported } from "@bestowinc/tinkertoy-client";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ThemeProvider } from "styled-components";

const el = document.getElementById("root");

if (el) {
  createRoot(el).render(
    <StrictMode>
      {/*
        TODO(FEP2-3139 follow-up): resolve the theme from `window.location.hostname`
        the same way real host apps (EC, CP, verify, microsites) do — typically
        `getCarrierConfigByPartnerId(...).theme` with a dev fallback. The modern
        shell takes a `theme` arg in `mountShell({ theme })` and pushes that
        decision to its host; the fallback bundle ships standalone and has to
        do its own resolution, so until that lookup lands here we hard-code
        Bestow's purple theme and accept that carrier-themed legacy users
        briefly see Bestow branding before they upgrade.
      */}
      <ThemeProvider theme={PURPLE_THEME}>
        <BrowserNotSupported />
      </ThemeProvider>
    </StrictMode>,
  );
}
